import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionList = (
  payload = { module_type: 'BPLS' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION,
    'api/temp/administrators/transaction_histories/business_permit',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    callback,
    payload,
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.SYNC_RECORD,
    `api/temp/administrators/transaction_histories/business_permit/${id}/approve`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const receiveTransaction = (id, payload, callback) =>
  req.update(
    c.RECEIVE_TRANSACTION,
    `api/temp/administrators/transaction_histories/business_permit/${id}/tag_as_received`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const rejectTransaction = (id, payload, callback) =>
  req.update(
    c.REJECT_TRANSACTION,
    `api/temp/administrators/transaction_histories/business_permit/${id}/reject`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const fetchRecord = (id, payload, callback) =>
  req.update(
    c.FETCH_RECORD,
    `api/temp/administrators/transaction_histories/business_permit/${id}/fetch`,
    payload,
    callback,
    { defaultMessage: false }
  );

export const syncRecord = (id, payload, callback) =>
  req.update(
    c.SYNC_RECORD,
    `api/temp/administrators/transaction_histories/business_permit/${id}/sync`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Data Found');
      if (callback) callback();
    }
  );

export const checkTransmittal = (payload, callback) =>
  req.list(
    c.BPLS_CHECK_TRANSMITTAL,
    `api/v1/administrators/transaction_histories/transmital/check_batch_number`,
    payload,
    callback
  );

export const reComputeTransaction = (id, payload, callback) =>
  req.update(
    c.RECOMPUTE,
    `api/temp/administrators/transaction_histories/business_permit/${id}/recompute`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const updateBusinessTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_BUSINESS_TRANSACTION,
    `api/temp/administrators/transaction_histories/business_permit/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

  export const addBusinessRemarks = (id, payload, callback) => 
  req.update(
    c.ADD_BUSINESS_REMARKS,
    `api/temp/administrators/transaction_histories/business_permit/${id}/update_remarks`,
    payload,
    () => {
      if (callback) callback();
    }
  )


export const revokeTransaction = (id, payload, callback) =>
req.create(
  c.BPLS_TEMP_REVOKE,
  `api/temp/administrators/transaction_histories/business_permit/${id}/revoke_permit`,
  payload,
  callback,
  res => {
    const { message } = res.res;
    alert.success(message || 'Successfully Updated !');
    if (callback) callback();
  }
);

export const deleteTransaction = (id, payload, callback) =>
  req.remove(
    c.DELETE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    callback,
    payload
  );